import { ISvgProps, Svg } from '@components';
import { memo } from 'react';

export const CircleCrossIcon = memo<ISvgProps>((props, { className }) => (
  <Svg className={className} width="24" height="25" viewBox="0 0 24 25" {...props}>
    <path
      d="M12 24.1113C18.6274 24.1113 24 18.7387 24 12.1113C24 5.48391 18.6274 0.111328 12 0.111328C5.37258 0.111328 0 5.48391 0 12.1113C0 18.7387 5.37258 24.1113 12 24.1113Z"
      fill="#E33559"
    />
    <path d="M8 8.11133L15.9997 16.111" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
    <path d="M16 8.11133L8.00035 16.111" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
    <path d="M8 8.11133L15.9997 16.111" stroke="white" strokeWidth="2" strokeLinecap="round" />
    <path d="M16 8.11133L8.00035 16.111" stroke="white" strokeWidth="2" strokeLinecap="round" />
  </Svg>
));

CircleCrossIcon.displayName = 'CircleCrossIcon';

export default CircleCrossIcon;
